import type Calendar from 'rc-year-calendar';

// this is the best way I could come up with to do this
// rc-year-calendar does come with translations, but they aren't the best, as such, we're overriding translations that we're using in the app
export function overrideCalendarTranslations(calendar: Calendar) {
	// en is baked in (and is fine) except for it starting on Sunday
	calendar.locales.en.weekStart = 1;

	calendar.locales.pl = {
		days: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
		daysShort: ['nie', 'pon', 'wto', 'śro', 'czw', 'pt', 'sob'],
		daysMin: ['nd', 'po', 'wt', 'śr', 'cz', 'pt', 'sb'],
		months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
		monthsShort: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
		weekShort: 'T',
		weekStart: 1
	};

	calendar.locales.ru = {
		days: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
		daysShort: ['Вск', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'],
		daysMin: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
		months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
		monthsShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
		weekShort: 'н',
		weekStart: 1
	};
}